import React, {Fragment} from 'react';
import {Form, Select, Button, Icon, Radio} from 'antd';

import week from './../data/week.json';
import RadioGroup from "antd/lib/radio/group";

const {Item} = Form;
const {Option} = Select;


export class AppointmentForm extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onSelectService = (serviceId) => {
        const {getSchedules, handleSelectService} = this.props;
        if (this.props.schedules.selectedGender == null) {
            handleSelectService(serviceId);
            return;
        }

        if (this.props.form.getFieldValue('cabinetId')) {
            this.props.form.setFieldsValue({cabinetId: undefined});
        }
        getSchedules(serviceId);
        handleSelectService(serviceId);
    };

    onSelectCabinet = (cabinetId) => {
        this.props.handleSelectCabinet(cabinetId)
    };

    onChangeGender = (event) => {
        const {getSchedules, handleSelectGender} = this.props;
        if (this.props.schedules.selectedServiceId == null) {
            handleSelectGender(event.target.value);
            return;
        }

        getSchedules(this.props.schedules.selectedServiceId, event.target.value);
        handleSelectGender(event.target.value);
    };

    handleSelectSchedule = (cabinetId, row, col) => {
        this.props.selectSchedule(cabinetId, row, col);
        window.scrollTo(0, window.innerHeight);
    };

    render() {
        const {services, schedules, getSchedules, pageText} = this.props;
        const {selectedServiceId, selectedCabinetId, selectedSchedule, selectedGender} = schedules;
        return (
            <div>
                <div className={"gcm-m-records-page-text"} dangerouslySetInnerHTML={{ __html: pageText }} />
                <Item className={"gcm-m-gender-selector"}>
                    <RadioGroup onChange={this.onChangeGender} name={"gender"} defaultValue={selectedGender}>
                        <Radio value={"male"}>Мужской</Radio>
                        <Radio value={"female"}>Женский</Radio>
                    </RadioGroup>
                </Item>
                <Item label="Услуги">
                    <Select style={{width: '100%'}} defaultValue={selectedServiceId} size="large" placeholder="Услуга"
                            onChange={this.onSelectService}>
                        {services.map(service => (
                            <Option value={service.id} key={service.id}>{service.name}</Option>
                        ))}
                    </Select>
                </Item>
                {schedules.selectedServiceId && schedules.cabinetIds.length > 1 && (
                    <Item label="Кабинет">
                        <Select style={{width: '100%'}} defaultValue={selectedCabinetId} size="large"
                                placeholder="Кабинет" onChange={this.onSelectCabinet}>
                            {schedules.cabinetIds.map(id => (
                                <Option value={id} key={id}>{id}</Option>
                            ))}
                        </Select>
                    </Item>
                )}
                {schedules.selectedServiceId && schedules.selectedCabinetId && (
                    <div style={{marginBottom: 15}}>
                        <div style={{
                            display: 'flex',
                            justifyContent: schedules.offset > 0 ? 'space-between' : 'flex-end',
                            marginBottom: 15
                        }}>
                            {schedules.offset > 0 && (
                                <Button
                                    size="small"
                                    onClick={() => getSchedules(selectedServiceId, schedules.selectedGender, schedules.offset - 1)}
                                >
                                    <Icon type="left"/>Предыдущая неделя
                                </Button>
                            )}
                            <Button
                                size="small"
                                onClick={() => getSchedules(selectedServiceId, schedules.selectedGender, schedules.offset + 1)}
                            >
                                Следующая неделя<Icon type="right"/>
                            </Button>
                        </div>
                        <div style={{overflowX: 'auto'}}>
                            <table className="gcm-m-appointment-table">
                                <tbody>
                                <tr>
                                    {schedules.cabinets[selectedCabinetId].dates.map((date, i) => (
                                        <th className="gcm-m-appointment-table-header" key={date}>
                                            <p>{week[i]}</p>
                                            <p>{date}</p>
                                        </th>
                                    ))}
                                </tr>
                                {schedules.cabinets[selectedCabinetId].schedules.map((row, rowId) => (
                                    <tr key={rowId}>
                                        {row.map((column, columnId) => (
                                            column ? (
                                                <td
                                                    key={columnId}
                                                    className={`gcm-m-appointment-table-item ${
                                                        column.isActive ? 'enabled' : 'disabled'
                                                    } ${column === schedules.selectedSchedule ? 'selected' : ''}`}
                                                    onClick={
                                                        column.isActive ?
                                                            () => this.handleSelectSchedule(column) :
                                                            null
                                                    }
                                                >
                                                    {}
                                                    {(new Date().getTime() - new Date(column.date.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3")).getTime()) > 0 ? (
                                                        <p>Запись завершена</p>
                                                    ) : (
                                                        <Fragment>
                                                            <p className="time">{column.timeStart}</p>
                                                            <p>Талонов: {column.ticket}</p>
                                                        </Fragment>
                                                    )
                                                    }
                                                </td>
                                            ) : (
                                                <td key={columnId} className="gcm-m-appointment-table-item disabled">
                                                    <p>Записи нет</p>
                                                </td>
                                            )
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
                <Button
                    style={{width: '100%'}}
                    size="large"
                    disabled={!selectedCabinetId || !selectedServiceId || !selectedSchedule}
                    onClick={this.props.next}
                >Далее</Button>
            </div>
        );
    }
}

export default Form.create()(AppointmentForm);



// WEBPACK FOOTER //
// frontend/src/modules/mobile/components/AppointmentForm.jsx